
export class Vehicle {
    constructor(
        public id: number = null,
        public licensePlate: string = '',
        public permitNumber: string = '',
        public year: string = '',
        public color: string = '',
        public note: string = '',
        public brand: string = '',
        public model: string = '',
        public ownerId: number = null,
        public ownerName: string = '',
        public moveOutDate: string = '',
        public suiteId: number = null,
        public suiteNumber: string = '',
        public buildingId: number = null,
        public buildingName: string = '',
        public checked: boolean = false,
        public isCanEdit: boolean = true,
        public isCanDelete: boolean = true,
        public formFields = {
            licensePlate: {editMode: false},
            permitNumber: {editMode: false},
            year: {editMode: false},
            color: {editMode: false},
            note: {editMode: false},
            brand: {editMode: false},
            model: {editMode: false},
            ownerId: {editMode: false},
        }
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/Vehicle.ts